<template>
  <div class="grid grid-cols-8">
    <div class="ml-4 flex w-full items-center">
      <status-indicator-component
        :status="investment.status"
        :position="investment.position_status"
        :error="toggle_disabled"
        class="mr-2"
      />
      <ontick-toggle-component
        v-show="investment.status != 'HIDDEN'"
        class=""
        :class="toggle_disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
        :active="investment.status == 'RUNNING' ? true : false"
        :block="toggle_disabled"
        size="sm"
        @switch="
          $emit('toggleSwitch', {
            investmentId: investment.investment_id,
            investmentStatus: investment.status,
            toogle: (toggle_disabled =
              investment.status === 'RUNNING' ? false : toggle_disabled),
          }),
            selectedParams({ value: typed_volume, item: investment })
        "
      />
      <ontick-form-dropdown
        offset
        content="Outras opções"
        v-tippy="{ arrow: true, theme: 'green' }"
        :position="'left'"
        :optionCard="true"
        :disabledOptionDefault="true"
        :optionInitial="optionDefault"
        :options="optionsSelect"
        :footer="investment.investment_id"
        @optionSelected="optionSelected($event, investment)"
        bg="bg-transparent"
      ></ontick-form-dropdown>
    </div>
    <!-- <div class="td">
      <div class="flex items-center space-x-1">
        <product-type-component :type="investment.type" />
        <button
          class="transform text-gray-500 transition-all"
          :class="dropdownIsActive ? '' : 'rotate-180'"
          v-if="investment.type === 'PORTFOLIO'"
          @click="togglePortfolioDropdown"
        >
          <i v-html="$icons.chevron_drop_up"></i>
        </button>
      </div>
    </div> -->
    <div
      class="name relative truncate !text-left"
      :content="investment.strategy_name"
      v-tippy="{ arrow: true, theme: 'green' }"
    >
      <div class="flex items-center space-x-2">
        <img
          :src="investment.partner_badge"
          class="h-4 w-4"
          alt=""
          v-if="investment.partner_badge"
        />
        <span>
          {{ investment.strategy_name }}
        </span>
      </div>
      <div
        class="dark:to-ontick-graphite-500 absolute top-0 right-0 h-full w-6 bg-gradient-to-r from-transparent to-gray-200"
      ></div>
    </div>
    <div class="td">
      <span v-if="investment.strategy_symbol === 'PORTFOLIO'"> - </span>
      <span
        v-else
        class="bg-ontick-blue-900 text-ontick-blue-300 flex items-center justify-center rounded-sm px-2 py-0.5 text-xs"
      >
        {{ investment.strategy_symbol }}
      </span>
    </div>
    <div class="td">
      <span v-if="investment.strategy_symbol === 'PORTFOLIO'"> - </span>
      <span
        v-else
        class="bg-ontick-teal-600 text-ontick-teal-50 flex items-center justify-center rounded-sm px-2 py-0.5 text-xs"
      >
        {{ investment.strategy_timeframe }}
      </span>
    </div>

    <div
      class="td col-span-2 justify-between"
      v-if="investment.strategy_market === 'Equities'"
    >
      <ontick-number-input
        v-if="
          investment.type !== 'PORTFOLIO' &&
          investment.volume_type === 'QUANTITY'
        "
        size="mini"
        v-model="typed_volume"
        :min="investment.min_volume"
        :max="investment.max_absolute_volume"
        :step="investment.volume_step"
        class="w-full"
      />
      <template v-else>
        <span v-if="isLoading" class="flex w-full items-center">
          <i v-html="$icons.loading" class="text-ontick-blue-600"></i>
          <span class="sr-only"> Carregando </span>
        </span>
        <span
          v-else
          class="w-full"
          content="Quantidade de ações"
          v-tippy="{ arrow: true, theme: 'green' }"
        >
          {{ investment.qtd_volume }}
        </span>
      </template>
      <button
        content="Alternar entre quantidade de ações e volume financeiro"
        v-tippy="{ arrow: true, theme: 'green' }"
        @click="changeMode"
        class="flex items-center justify-center px-2"
      >
        <div class="rotate-90 transform">
          <i v-html="$icons.swap" class="text-ontick-green-600"></i>
          <span class="sr-only">
            Alternar entre quantidade de ações e volume financeiro
          </span>
        </div>
      </button>
      <ontick-number-input
        v-if="
          investment.type !== 'PORTFOLIO' &&
          investment.volume_type === 'FIN_VOLUME'
        "
        size="mini"
        v-model="typed_volume"
        :min="investment.min_volume"
        :max="investment.max_absolute_volume"
        :step="financialStep"
        currency
        class="w-full"
      />
      <template v-else>
        <span v-if="isLoading" class="flex w-full items-center">
          <i v-html="$icons.loading" class="text-ontick-blue-600"></i>
          <span class="sr-only"> Caregando </span>
        </span>
        <span
          v-else
          class="w-full whitespace-nowrap text-center font-bold uppercase"
        >
          {{ investment.fin_volume | currency }}
        </span>
      </template>
    </div>
    <template v-else>
      <div class="td">
        <ontick-number-input
          v-if="investment.type !== 'PORTFOLIO'"
          size="mini"
          v-model="typed_volume"
          :min="investment.min_volume"
          :max="investment.max_absolute_volume"
          :step="investment.volume_step"
          :currency="investment.strategy_market === 'Equities'"
        />
      </div>
      <div class="td whitespace-nowrap font-bold uppercase">
        {{
          (typed_volume * (investment.min_capital / investment.volume_step))
            | currency
        }}
      </div>
    </template>
    <div
      class="td !text-ontick-red-700 dark:!text-ontick-red-600 whitespace-nowrap"
    >
      {{ maxLoss | currency }}
    </div>
    <div
      class="td !text-ontick-green-700 dark:!text-ontick-green-600 whitespace-nowrap"
    >
      {{ maxGain | currency }}
    </div>
  </div>
</template>

<script>
import * as icons from "@/app/assets/icons/investments";
import OntickToggleComponent from "../../../ontick-toggle/ontick-toggle.component.vue";
import statusIndicatorComponent from "../../card-investment/status-indicator.component.vue";
import { mapActions } from "vuex";
import ProductTypeComponent from "../product-type.component.vue";

export default {
  props: {
    investment: {
      type: Object,
      required: true,
    },
  },
  components: {
    OntickToggleComponent,
    statusIndicatorComponent,
    ProductTypeComponent,
  },
  data() {
    return {
      toggle_disabled: false,

      typed_volume: this.investment.curr_volume,

      optionDefault: {
        icon: icons.details,
        label: null,
      },
      optionsSelect: [
        { icon: icons.editParams, label: "Parâmetros" },
        { icon: icons.performance, label: "Histórico" },
        {
          icon: icons.removeInvestment,
          label:
            this.investment.status != "HIDDEN" ? "Arquivar" : "Desarquivar",
        },
      ],
      dropdownIsActive: false,
      volumeType: this.investment.volume_type,
      financialVolume: this.investment.financialVolume,
      quantityVolume: this.investment.quantityVolume,
      financialStep: 1000,
      isWaitingForData: false,
      timeout: null,
    };
  },
  computed: {
    isLoading() {
      return (
        this.investment.strategy_market === "Equities" && this.isWaitingForData
      );
    },
    maxLoss() {
      return this.investment.strategy_market === "Equities"
        ? this.investment.max_loss
        : this.typed_volume * this.investment.max_daily_loss;
    },
    maxGain() {
      return this.investment.strategy_market === "Equities"
        ? this.investment.max_gain
        : this.typed_volume * this.investment.max_daily_gain;
    },
    portfolioPosition() {
      if (
        this.investment.components.every(
          (component) =>
            component.position_status ===
            this.investment.components[0].position_status
        )
      ) {
        return this.investment.components[0].position_status;
      } else {
        return "-";
      }
    },
    portfolioVolume() {
      let volumeArray = [];
      for (const component in this.investment.components) {
        if (component.position_volume) {
          volumeArray.push(component.position_volume);
        }
      }
      if (volumeArray.length) {
        return volumeArray.reduce((acc, curr) => acc + curr);
      } else {
        return "-";
      }
    },
    volume() {
      if (this.investment.type === "PORTFOLIO") {
        return this.portfolioVolume;
      } else if (this.investment.position_volume) {
        return this.investment.position_volume;
      } else {
        return "-";
      }
    },
  },
  methods: {
    ...mapActions({
      selectedParams: "investment/selectedParams",
      setInvestmentVolumeType: "investment/setInvestmentVolumeType",
      setInvestmentVolume: "investment/setInvestmentVolume",
      setGainLoss: "investment/setGainLoss",
    }),
    getVolumeCheck() {
      if (this.investment.strategy_market === "Equities")
        this.setGainLoss({
          investment_id: this.investment.investment_id,
        })
          .catch(() => {})
          .finally(() => {
            this.isWaitingForData = false;
          });
    },
    volumeCheckHandler() {
      this.isWaitingForData = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.getVolumeCheck(), 500);
    },
    changeMode() {
      if (this.investment.volume_type === "FIN_VOLUME") {
        this.setInvestmentVolumeType({
          investment_id: this.investment.investment_id,
          volume_type: "QUANTITY",
        });
        this.typed_volume = this.investment.qtd_volume;
      } else if (this.investment.volume_type === "QUANTITY") {
        this.setInvestmentVolumeType({
          investment_id: this.investment.investment_id,
          volume_type: "FIN_VOLUME",
        });
        this.typed_volume = this.investment.fin_volume;
      }
    },
    togglePortfolioDropdown() {
      this.dropdownIsActive = !this.dropdownIsActive;
      this.$emit("toggle-portfolio-dropdown", this.investment.investment_id);
    },
    optionSelected(event, investment) {
      const labelList = {
        Parâmetros: () => {
          this.$router.push({
            path: "/investments/" + Number(investment.investment_id) + "/edit",
          });
        },
        Histórico: () => {
          this.$router.push({
            name: "Histórico",
            params: {
              id: Number(investment.investment_id),
              label: investment.strategy_name,
            },
          });
        },
        Arquivar: () => {
          if (investment.status == "STOPPED") {
            this.$api
              .post(this.$endpoint.INVESTMENT_HIDE, {
                investment_id: Number(investment.investment_id),
              })
              .then((response) => {
                this.$swal({
                  title: response.data.msg,
                  icon: "success",
                  icon: "success",
                  iconHtml: this.$icons.swal_success,
                });
                this.getInvestments();

                // this.$emit("reload", { investmentActiveOrHidden: "ACTIVE" });
              });
          } else if (investment.status == "RUNNING") {
            this.$swal({
              title: "Você deve parar o investimento para ocultá-lo",
              icon: "error",
              timer: 8000,
            });
          }
        },
        Desarquivar: () => {
          if (investment.status == "HIDDEN") {
            this.$api
              .post(this.$endpoint.INVESTMENT_SHOW, {
                investment_id: Number(investment.investment_id),
              })
              .then((response) => {
                this.$swal({
                  icon: "success",
                  icon: "success",
                  iconHtml: this.$icons.swal_success,
                  title: response.data.msg,
                });
                // this.$emit("reload", { investmentActiveOrHidden: "HIDDEN" });
                this.getInvestments();
              });
          }
        },
      };
      labelList[event.label]();
    },
  },

  watch: {
    "investment.volume_type": {
      handler(val) {
        if (this.investment.strategy_market === "Equities") {
          this.setInvestmentVolumeType({
            investment_id: this.investment.investment_id,
            volume_type: val,
          });
          this.volumeCheckHandler();
        }
      },
    },
    typed_volume: {
      handler(val) {
        if (this.investment.strategy_market === "Equities") {
          this.volumeCheckHandler();
          this.setInvestmentVolume({
            investment_id: this.investment.investment_id,
            volume: val,
          });
        }
      },
    },
  },

  created() {
    this.isWaitingForData = true;
    this.getVolumeCheck();
  },
};
</script>

<style lang="scss" scoped>
.td {
  @apply text-ontick-carbon-900 flex items-center px-4 py-3 text-left text-xs dark:text-gray-300;
}
.name {
  @apply text-ontick-carbon-900 flex items-center py-3 pl-4 text-left text-xs dark:text-gray-300;
}
</style>
